/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Save_ErrorInputs */

const en_link_editor_save_error = /** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save links.`)
};

const es_link_editor_save_error = /** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al guardar los enlaces.`)
};

const fr_link_editor_save_error = /** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'enregistrement des liens.`)
};

const de_link_editor_save_error = /** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern der Links.`)
};

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const ja_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const zh_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const ar_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const id_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const it_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const ru_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const pt_link_editor_save_error = en_link_editor_save_error;

/** @type {(inputs: Link_Editor_Save_ErrorInputs) => LocalizedString} */
const ko_link_editor_save_error = en_link_editor_save_error;

/**
* | output |
* | --- |
* | "Failed to save links." |
*
* @param {Link_Editor_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_save_error = /** @type {((inputs?: Link_Editor_Save_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Save_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_save_error(inputs)
	if (locale === "es") return es_link_editor_save_error(inputs)
	if (locale === "fr") return fr_link_editor_save_error(inputs)
	if (locale === "de") return de_link_editor_save_error(inputs)
	if (locale === "ja") return ja_link_editor_save_error(inputs)
	if (locale === "zh") return zh_link_editor_save_error(inputs)
	if (locale === "ar") return ar_link_editor_save_error(inputs)
	if (locale === "id") return id_link_editor_save_error(inputs)
	if (locale === "it") return it_link_editor_save_error(inputs)
	if (locale === "ru") return ru_link_editor_save_error(inputs)
	if (locale === "pt") return pt_link_editor_save_error(inputs)
	return ko_link_editor_save_error(inputs)
});